/* eslint-env browser */
// Entry point for the build script in your package.json
import { detectSpanishCountry } from './helpers/ipGeolocation';
import './helpers/termsLinkManager';
import { createLdClientWithFallback } from './modules/shared/featureFlags';
import { getAnonymousLdClient } from './shared/ldAnonymousClient';

// Detect Spanish country on page load (non-blocking)
if (typeof window !== 'undefined') {
  // Reuse the shared anonymous LaunchDarkly client for feature flags
  const ldClient = createLdClientWithFallback(getAnonymousLdClient());

  ldClient
    .waitForInitialization(5)
    .then(() => {
      const detectSpanishCountryEnabled = ldClient.variation('detect-spanish-country', false);
      if (detectSpanishCountryEnabled) {
        detectSpanishCountry();
      }
    })
    .catch(error => {
      console.error('LaunchDarkly initialization failed:', error);
      // Default to disabled if LaunchDarkly fails
    });
}
